<template>
  <div>
    <!-- -------------------Búsqueda simple COLECCIONES ------------------------------------ -->
    <div class="Blk-Res">
    <div v-for="(resultado, index) in resultados" :key="index">
      <p class="titular">{{ resultado[1].length !== 0 ? `${resultado[0]}: ${resultado[1].length}` : ''}}</p>
      <div class="" v-for="(res, index2) in resultado[1]" :key="index2">
         <!-- ------------------------------------------------------------------------------- -->
        <div v-if="resultado[0] === 'Libros'  && resultado[1].length !== 0">
          <p class="L1">{{res.titulo}}</p>
          <p class="L12">{{ res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}</p>
          <!-- <p class="L2" v-html="resalta(resultado.localizacion)"></p>
          <p class="L2" v-html="resalta(resultado.topo)"></p>
          <p class="L3">BSVE: {{resultado.boletin}}</p>
          <p class="L1">Hola</p> -->
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Ediciones periódicas'">
          <p class="L1">{{res.pertNomCort}}
            {{res.volumen ? (' Vol. ' + res.volumen  + '-') : `` }}
            {{res.numero ? ('Núm. ' + res.numero) : `` }} - {{res.anyo}}</p>
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Índice</p>
              <p class="up" @click="verIndice(res._id)" v-show="!indicesVisibles.some(e => e === res._id)">&dtrif;</p>
              <p class="down" v-show="indicesVisibles.some(e => e === res._id)" @click="ocultarIndice(res._id)">&utrif;</p>
            </div>
            <!-- <p class="resumenT" v-show="indicesVisibles.some(e => e === res._id)" v-html="resalta(resultado.zonaCarstica)">{{res.indice}}</p> -->
            <p class="resumenT" v-show="indicesVisibles.some(e => e === res._id)" v-html="resalta(res.indice)"></p>
          </div>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Resúmenes Congresos'">
          <p class="L1">{{res.nombre}}</p>
          <p class="L12">{{ res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}</p>
          <p class="L2">{{res.congresoYfecha}}</p>
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Resumen</p>
              <p class="up" @click="verResumen(res._id)" v-show="!resumenesVisibles.some(e => e === res._id)">&dtrif;</p>
              <p class="down" v-show="resumenesVisibles.some(e => e === res._id)" @click="ocultarResumen(res._id)">&utrif;</p>
            </div>
            <p class="resumenT" v-show="resumenesVisibles.some(e => e === res._id)" v-html="resalta(res.resumen)"></p>
          </div>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Artículos/Separatas'">
          <p class="L1">{{res.titulo}}</p>
          <p class="L12">{{ res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}</p>
          <p class="L2">{{res.publicacion}}, {{res.volumen ? (' Vol. ' + res.volumen  + '-') : `` }}
            {{res.numero ? ('Núm. ' + res.numero) : `` }} - {{res.anyo}}</p>
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Resumen</p>
              <p class="up" @click="verResumen(res._id)" v-show="!resumenesVisibles.some(e => e === res._id)">&dtrif;</p>
              <p class="down" v-show="resumenesVisibles.some(e => e === res._id)" @click="ocultarResumen(res._id)">&utrif;</p>
            </div>
            <p class="resumenT" v-show="resumenesVisibles.some(e => e === res._id)" v-html="resalta(res.resumen)"></p>
          </div>
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Abstract</p>
              <p class="up" @click="verAbstract(res._id)" v-show="!abstractsVisibles.some(e => e === res._id)">&dtrif;</p>
              <p class="down" v-show="abstractsVisibles.some(e => e === res._id)" @click="ocultarAbstract(res._id)">&utrif;</p>
            </div>
            <p class="resumenT" v-show="abstractsVisibles.some(e => e === res._id)" v-html="resalta(res.abstract)"></p>
          </div>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Literatura gris'">
          <p class="L1">{{res.titulo}}</p>
          <p class="L12">{{ res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}</p>
          <!-- Aquí hay que poner el tipo de documento y el área que están en código numérico en la BD-->
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Resumen</p>
              <p class="up" @click="verResumen(res._id)" v-show="!resumenesVisibles.some(e => e === res._id)">&dtrif;</p>
              <p class="down" v-show="resumenesVisibles.some(e => e === res._id)" @click="ocultarResumen(res._id)">&utrif;</p>
            </div>
            <p class="resumenT" v-show="resumenesVisibles.some(e => e === res._id)" v-html="resalta(res.resumen)"></p>
          </div>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Hemerografías'">
          <p class="L1">{{res.titulo}}</p>
          <p class="L12">{{ res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}</p>
          <div class="L2">
            {{res.publicacion}}
            {{res.ciudad ? (' | ' + res.ciudad) : `` }}
            {{res.pais ? (' - ' + res.pais) : `` }}
            {{res.fecha ? (' | ' + res.fecha) : `` }}
          </div>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Misceláneos'">
          <p class="L1">{{res.titulo}}</p>
          <p class="L12">{{ res.autores ? res.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') : '' }}</p>
          <p class="resumenT">{{res.tipoElemento}}</p>
          <div class="L2">
            {{res.editorial}}
            {{res.ciudad ? (' | ' + res.ciudad) : `` }}
            {{res.pais ? (' - ' + res.pais) : `` }}
          </div>
          <p class="resumenT">{{res.descripcion}}</p>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Sellos'">
          <p class="L1">{{res.titulo}}</p>
          <div class="L2">
            {{res.pais ? res.pais : `` }} {{res.anyo ? (' - ' + res.anyo) : ``}}
            {{res.valor ? (' - ' + res.valor) : ``}} {{res.moneda ? (' ' + res.moneda) : ``}}
          </div>
          <p class="resumenT">{{res.comments}}</p>
        </div> <!-- ------------------------------------------------------------------------------------- -->
        <div v-else-if="resultado[0] === 'Postales'">
          <p class="L1">{{res.titulo}}</p>
          <div class="L2">
            {{res.pais ? res.pais : `` }} {{res.anyo ? (' - ' + res.anyo) : ``}}
          </div>
          <p class="resumenT">{{res.comments}}</p>
        </div> <!-- ------------------------------------------------------------------------------------- -->
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modPreResColGen',
  props: {
    resultados: Array,
    palabra: String
  },
  data () {
    return {
      resumenesVisibles: [],
      abstractsVisibles: [],
      desplegado: false,
      deploid: false,
      indicesVisibles: [],
      desplegado1: false
    }
  },
  methods: {
    // resalta (frase) {
    //   var palB = this.palabra
    //   if (palB.includes(' ')) {
    //     palB = palB.split(' ')[0].replace('"', '').trim()
    //   }
    //   let fraseElem = frase.replace('-', ' - ')
    //   fraseElem = fraseElem.split(' ')
    //   const fraseEleTr = fraseElem.map(e => {
    //     const Orig = e.normalize('NFD').replace(/\.|"|'|-|,|[\u0300-\u036f]/gi, '')
    //     const Busc = palB.normalize('NFD').replace(/[\u0300-\u036f]/gi, '')
    //     if (Orig.toLowerCase() === Busc.toLowerCase()) { return `<mark>${e}</mark>` } else { return e }
    //   })
    //   const fraseTr = fraseEleTr.join(' ')
    //   return fraseTr
    // },
    resalta (frase) {
      if (frase) {
        const regex = new RegExp(`(${this.palabra})`, 'gi')
        return frase.replace(regex, '<mark>$1</mark>')
      }
    },
    verResumen (ID) {
      this.resumenesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    verAbstract (ID) {
      this.abstractsVisibles.push(ID)
      this.deploid = !this.deploid
    },
    ocultarResumen (ID) {
      this.resumenesVisibles = this.resumenesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    },
    ocultarAbstract (ID) {
      this.abstractsVisibles = this.abstractsVisibles.filter(e => e !== ID)
      this.deploid = !this.deploid
    },
    verIndice (ID) {
      this.indicesVisibles.push(ID)
      this.desplegado1 = !this.desplegado1
    },
    ocultarIndice (ID) {
      this.indicesVisibles = this.indicesVisibles.filter(e => e !== ID)
      this.desplegado1 = !this.desplegado1
    }
  },
  computed: {

  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.Blk-Res{
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px gray;
  padding: 10px 10px;
  width: 98%;
  display: flex;
  flex-direction: column;
}
.titular{
  text-align: left;
  font-weight: 700;
  color : rgb(1, 61, 102);
  margin: 6px 0;
  font-size: 18px
}
.L1{
  text-align: left;
  font-size: 80%;
  font-weight: 700;
  color: rgb(30, 119, 161);
  padding-top: 8px;
  border-top: solid 0.5px rgb(184, 184, 184)
}
.L12{
  text-align: left;
  font-size: 75%;
  font-weight: 700;
  color : black;
}
.L2{
  font-size: 12px;
  text-align: left;
  color : black;
  font-size: 75%;
  /* width: 95%; */
}
.L3{
  text-align: left;
  font-size: 80%;
  font-weight: 700;
  color: rgb(105, 105, 105);
  margin-top: 3px;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(1, 56, 82)
}
.resumenT{
  text-align: left;
  font-size: 13px;
  width: 100%;
}
.lineaResumen{
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 100%;
}
.resumen{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 11px;
  color: rgb(82, 82, 82);
}
.up, .down{
  cursor:pointer;
  font-size: 25px;
  padding-bottom: 2px;
  color: rgb(68, 169, 216);
}
.P1{
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* padding: 3px; */
}
.P11{
  display: flex;
  width: 55%;
  margin-top: 10px;
  margin-left: 5px;
  /* border: solid 0.5px orange; */
}
.P12{
  display: flex;
  width: 20%;
  margin-top: 10px;
  /* border: solid 0.5px orange; */
}
.P1 h4{
  color:black;
  font-weight: 600;
  font-size: 1.2vw;
  margin: 0 3px;
  align-self: center;
}
.sliderBar{
  margin: 10px 0;
  width: 80%
}
.formInd{
  margin-top: 55px;
}

@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;

  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  #nombreSeparata{
    max-width: 96%;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }

}
</style>
